// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3klaX","col":"CardReaderDesc_col__1ZRl9","label":"CardReaderDesc_label__2tutz"};